import "javascripts/application";
import "javascripts/partials/top/top";
import "stylesheets/top";

require.context("../images", true, /\.(png|jpg|jpeg|svg)$/);
